import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { CenterChildDto } from "@malirang/api-client";
import { injectQueryParams } from "ngxtension/inject-query-params";
import { PreDocumentList } from "../../components/pre-document/pre-document-list/pre-document-list";
import { DocumentStore } from "../../store/document.store";
import { DocumentChildInfo } from "../document-child-info/document-child-info";
import { DocumentSelectChild } from "./child/document-select-child";

@Component({
    selector: "app-document-select",
    templateUrl: "./document-select.html",
    styleUrls: ["./document-select.css"],
    imports: [
        CommonModule,
        DocumentSelectChild,
        DocumentChildInfo,
        PreDocumentList,
    ],
})
export class DocumentSelect {
    readonly router = inject(Router);
    readonly documentStore = inject(DocumentStore);

    currentChild = this.documentStore.currentChild;
    ticketId = injectQueryParams("ticketId");

    handleBack() {
        this.router.navigate(["/document"], {
            replaceUrl: true,
        });
    }

    handleSelectChild(child: CenterChildDto | null) {
        if (!child) {
            return;
        }

        this.router.navigate([], {
            queryParams: {
                centerChildId: child.id,
            },
            queryParamsHandling: "merge",
        });
    }
}
